export default __webpack_public_path__ + "static/spartak-8b3bdc331ebc38c45ad242f0975918bb.svg";